import { inject, PLATFORM } from 'aurelia-framework';
import { io } from 'socket.io-client';
import { EventAggregator } from 'aurelia-event-aggregator';

// IO Connection
// let ioLink = io.connect( 'http://localhost:8083', { transports: ["websocket", "polling"] }  );
let ioLink = io.connect( 'https://app.samantia.com', { transports: ["websocket", "polling"] }  );

export const IOEvents = {
	MachineStatus	:"MachineStatus",
	DatasetUpload	:"DatasetUpload",
}


@inject(EventAggregator)
export class IoLink {

	constructor(ea){
		this.ea	= ea;
		/*	MARK: Listeners
			============================================
		*/
		ioLink.on('samantia::machines', ( (res) => {
			// Application Event Channel
			this.ea.publish(IOEvents.MachineStatus, res);
		}).bind(this))
	}
}
